import React, { useState } from "react";
import "./TechnoAep.css";
import "./TechnoAepDigital.css";
import Hero from "../components/SchoolInnerPageBanner";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;
const BASE = `${baseAPIUrl}assets/techno_aep_digital`;

const data = {
    "Class VIII": {
        Physics: {
            chapters: [
                {
                    name: "Force",
                    studyMaterial: `${BASE}/Physics_VIII_Chpt_01 (Force).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=Q0eW0AgXrfw"
                    ],
                    assignment: `${BASE}/Ass-1_Physics_Force_VIII_27.05.2026.pdf`,
                },
                {
                    name: "Friction",
                    studyMaterial: `${BASE}/Physics_VIII_Chpt_02 (Friction).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        },
        Chemistry: {
            chapters: [
                {
                    name: "Coal and Petroleum",
                    studyMaterial: `${BASE}/Chemistry_VIII (Coal & Petroleum) Chapter_01.pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=a0MIex0oj5w"
                    ],
                    assignment: `${BASE}/Assin_Chem_8_Chap-01 (Coal & Petroleum)Level-1 & 2.pdf`,
                },
                {
                    name: "Combustion and Flame",
                    studyMaterial: `${BASE}/Chem_VIII_Chap_02 (Combustion and Flame).pdf`,
                    videos: [],
                    assignment: '',
                },
            ],
        },
        Mathematics: {
            chapters: [
                {
                    name: "Squares and Squares Roots",
                    studyMaterial: `${BASE}/Math_VIII_Chapter_1 (Squares and Square Roors).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=shzYZis2af4",
                        "https://www.youtube.com/watch?v=0BSrZxmC8SU",
                        "https://www.youtube.com/watch?v=pStorj0TdTU",
                        "https://www.youtube.com/watch?v=hpwL0uDJyqA",
                        "https://www.youtube.com/watch?v=NMFiOpqABdA"
                    ],
                    assignment: `${BASE}/Assignment_Chapter_01_Math-VIII.pdf`,

                },
                {
                    name: "Cube and Cube Roots",
                    studyMaterial: `${BASE}/Math-VII_Chapter_2 (Cube and Cube Roots).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        },
        Biology: {
            chapters: [
                {
                    name: "Crop Production",
                    studyMaterial: `${BASE}/Biology-Class-VIII (Crop Production) Chapt-01.pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=SxDN06Ue8ns",
                        "https://www.youtube.com/watch?v=Am8e8B7Bd1U"
                    ],
                    assignment: `${BASE}/Ass_Biology_Chapter-01_Class-viii (Crop production).pdf`,
                },
                {
                    name: "Human Health",
                    studyMaterial: `${BASE}/Biology-VIII_Chapter-2 (Human Health).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        }
    },
    "Class IX": {
        Physics: {
            chapters: [
                {
                    name: "Motion",
                    studyMaterial: `${BASE}/Physics_IX_Chapter_1 (Motion).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=XqtU47_CyE0",
                        "https://www.youtube.com/watch?v=FzzjOwQeBc4"
                    ],
                    assignment: `${BASE}/Assi_Physics_IX Chpt-2 (Motion).pdf`
                },
                {
                    name: "Force & Laws of Motion",
                    studyMaterial: `${BASE}/Phy-IX_Chapter_02 (force & Laws of Motion).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        },
        Chemistry: {
            chapters: [
                {
                    name: "Exploring Mixtures and Their Separations",
                    studyMaterial: `${BASE}/Chemistry_IX_Chapter_01 (Exploring Mixture and their Separation).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=zgYELv58AqM",
                        "https://www.youtube.com/watch?v=5iEb8O6anSc"
                    ],
                    assignment: `${BASE}/Ass_Chemistry_IX Chapter_01 (Exploring Mixtures....).pdf`
                },
                {
                    name: "Atoms & Molelcules",
                    studyMaterial: `${BASE}/Chem_IX_Chap_02 (Atoms & Molelcules).pdf`,
                    videos: [],
                    assignment: ''
                },
            ],
        },
        Mathematics: {
            chapters: [
                {
                    name: "Co-ordinate Geometry",
                    studyMaterial: `${BASE}/Math-IX_Chapter_01 (Co-ordinate Geometry).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=-yUcIXf-lxo",
                        "https://www.youtube.com/watch?v=qKQ06jP_v00",
                        "https://www.youtube.com/watch?v=yEV-AhckHpY"
                    ],
                    assignment: `${BASE}/Ass_Math_Class-IX_Chapter_01.pdf`
                },
                {
                    name: "Polynomials",
                    studyMaterial: `${BASE}/Math_IX_Chap_02 (Polynomials).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        },
        Biology: {
            chapters: [
                {
                    name: "Cell",
                    studyMaterial: `${BASE}/Biology-IX_Chapter_01 (Cell).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=u2S_LoY1RAc",
                        "https://www.youtube.com/watch?v=7cvG7cf5CDw",
                        "https://www.youtube.com/watch?v=lh4XkfqksX8",
                        "https://www.youtube.com/watch?v=LV-LNPDDIA0"
                    ],
                    assignment: `${BASE}/Ass_Biology-IX_Chapter_01(Cell).pdf`
                },
                {
                    name: "Tissue",
                    studyMaterial: `${BASE}/Biology_IX_Chapter_02 (Tissue).pdf`,
                    videos: [
                    ],
                    assignment: '',
                },
            ],
        }
    },
    "Class X": {
        Physics: {
            chapters: [
                {
                    name: "Light Ray Optics",
                    studyMaterial: `${BASE}/Physics_Class_X (Light—Ray Optics).pdf`,
                    videos: [
                        "https://www.youtube.com/watch?v=IbDF3PW-mEk"
                    ],
                    assignment: ''
                },
            ],
        },
        Chemistry: {
            chapters: [
                {
                    name: "Chemical Reactions and Equations",
                    studyMaterial: `${BASE}/Chemistry-class-X_Chap-01 (Chemical Reaction...).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=OT1RYx_DuDc'
                    ],
                    assignment: `${BASE}/Ass_Chemistry_-X (Chemical Reactions & Equations).pdf`
                },
                {
                    name: "Acids, Base and Salts",
                    studyMaterial: `${BASE}/Chem_X_Chapter-2 (Acids, Base and Salts.pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ],
        },
        Mathematics: {
            chapters: [
                {
                    name: "Real Numbers",
                    studyMaterial: `${BASE}/Mathematics_Class_X Chapter_01 (Real Numbers).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=fsIprz51ziE',
                        'https://www.youtube.com/watch?v=1AAr7bs6HTU',
                        'https://www.youtube.com/watch?v=kbZURXvH7XY'
                    ],
                    assignment: `${BASE}/Ass_Math-Class-X_Chap-01 (Real Number).pdf  `
                },
                {
                    name: "Polynomials",
                    studyMaterial: `${BASE}/Math_X_ Chapter_02 (Polynomials).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ],
        },
        Biology: {
            chapters: [
                {
                    name: "Nutrition",
                    studyMaterial: `${BASE}/Biology_Class-X_Chap-01 (Life Process).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=aHvz3-Gr9Xw',
                        'https://www.youtube.com/watch?v=bCAgCIwrP_Y',
                        'https://www.youtube.com/watch?v=ynixWlTtvW8',
                        'https://www.youtube.com/watch?v=TRyHgtLRvWE',
                        'https://www.youtube.com/watch?v=0NNW5IY9uCU',
                        'https://www.youtube.com/watch?v=ghi7UV87PtE'
                    ],
                    assignment: `${BASE}/Ass._Biology_Class-X_Chap-01 (Life Processes).pdf  `
                },
                {
                    name: "Control & Coordination",
                    studyMaterial: `${BASE}/Biology-X_Chapter_02 (control & coordination).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ],
        }
    },
    "Class XI": {
        Physics: {
            chapters: [
                {
                    name: "Units and Measurement",
                    studyMaterial: `${BASE}/Physics_Class-XI_Chap_01 (Units and measurement).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=dpc0_FmSPPY',
                        'https://www.youtube.com/watch?v=lYtBVYlUKJM'
                    ],
                    assignment: `${BASE}/Ass_Physics XI (Units-measur).pdf`
                },
                {
                    name: "Kinemetics",
                    studyMaterial: `${BASE}/Phy-XI_Chapter_02 (Kinemetics).pdf`,
                    videos: [],
                    assignment: ''
                },
            ]
        },
        Chemistry: {
            chapters: [
                {
                    name: "Some Basic Concepts of Chemistry",
                    studyMaterial: `${BASE}/Chemistry-Class-XI Chapter_01 (Some Basic Concepts of Chemistry).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=NyySP2uq5_o'
                    ],
                    assignment: `${BASE}/Ass_Chemistry_XI (Some Basic Concept of Chemistry).pdf`
                },
            ]
        },
        Mathematics: {
            chapters: [
                {
                    name: "Set",
                    studyMaterial: `${BASE}/Math_XI_Chapter-01 (Set).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=LNqeUVDAaLE',
                        'https://www.youtube.com/watch?v=2gtyyIWUGI4'
                    ],
                    assignment: `${BASE}/Ass_Math-XI (Set).pdf`
                },
                {
                    name: "Relations & Functions",
                    studyMaterial: `${BASE}/Math-XI_Chapter_02 (Relations & Functions).pdf`,
                    videos: [],
                    assignment: ''
                },
            ]
        },
        Biology: {
            chapters: [
                {
                    name: "Biological Classification",
                    studyMaterial: `${BASE}/Biology-Class-XI Chapter_01 (Biological Classification).pdf`,
                    videos: [],
                    assignment: `${BASE}/Assi_Class-XI (Biological Classification).pdf`
                },
            ]
        }
    },
    "Class XII": {
        Physics: {
            chapters: [
                {
                    name: "Coulomb's Law",
                    studyMaterial: `${BASE}/Physics_Chpt_01_SM1_XII (Coulomb's Law).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=XUP7OIm3X2s',
                        'https://www.youtube.com/watch?v=NRr38BFvyIw',
                        'https://www.youtube.com/watch?v=AMJJvHFCWkw',
                        'https://www.youtube.com/watch?v=5w2Df0b5joc'
                    ],
                    assignment: `${BASE}/Ass_Physics_XII_(Coulomb's Law).pdf`
                },
                {
                    name: "Electric Field",
                    studyMaterial: `${BASE}/Phy_Chpt_02_XII (Electric Field).pdf`,
                    videos: [],
                    assignment: ''
                },
            ]
        },
        Chemistry: {
            chapters: [
                {
                    name: "Solution",
                    studyMaterial: `${BASE}/Chemistry-XII _Chapter_01 (Solution).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=Ixlrjfi_3Ng'
                    ],
                    assignment: `${BASE}/Ass_Chemistry-XII_Chap-01 (Solutions).pdf`
                },
            ]
        },
        Mathematics: {
            chapters: [
                {
                    name: "Reations & Functions",
                    studyMaterial: `${BASE}/Math_XII_Chapter_01 (Reations & Functions).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=OFnHvJF8gv0',
                        'https://www.youtube.com/watch?v=aX8L6-IN-hI',
                        'https://www.youtube.com/watch?v=kQ7okcBki6I',
                        'https://www.youtube.com/watch?v=kQ7okcBki6I',
                        'https://www.youtube.com/watch?v=hVSbDtxRQe8',
                        'https://www.youtube.com/watch?v=eWlK6ZrL4j8',
                        'https://www.youtube.com/watch?v=5oLpkb_WSC4',
                        'https://www.youtube.com/watch?v=WVZ4rTESMdE'
                    ],
                    assignment: `${BASE}/Math_XII_Chap-01(Relations & Functions).pdf`
                },
                {
                    name: "Inverse Trigonomitric",
                    studyMaterial: `${BASE}/Math-XII_Chap-02 (inverse Trigonomitric).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ]
        },
        Biology: {
            chapters: [
                {
                    name: "Sexual Reproduction of Plants",
                    studyMaterial: `${BASE}/Biology-XII_Chap_01(Sexual Reproduction of Plants).pdf`,
                    videos: [
                        'https://www.youtube.com/watch?v=pQudm6NgsNo',
                        'https://www.youtube.com/watch?v=owfP4Hzkq1w',
                        'https://www.youtube.com/watch?v=1aa0onvEvDo',

                    ],
                    assignment: `${BASE}/Ass_XII_chapter_01(Sexual Reproduction).pdf`
                },
                {
                    name: "Human Reproductive System",
                    studyMaterial: `${BASE}/Bio-XII_Chap_02 (Human Reproductive System).pdf`,
                    videos: [
                    ],
                    assignment: ''
                },
            ]
        }
    },
};

const TechnoAepDigital = () => {

    const [activeClass, setActiveClass] = useState("Class VIII");
    const [activeSubject, setActiveSubject] = useState("Physics");

    const [openVideoIndex, setOpenVideoIndex] = useState(null);

    // CLASS LIST
    const classes = Object.keys(data);

    // SUBJECT LIST BASED ON ACTIVE CLASS
    const subjects = Object.keys(data[activeClass] || {});

    // CHAPTER LIST BASED ON CLASS + SUBJECT
    const chapters =
        data[activeClass]?.[activeSubject]?.chapters || [];

    return (
        <div className="academics-page">

            <Hero image="/pictures/image.jpg" alt="tigps academics" />

            <section>
                <div className="outer-container">

                    {/* CLASS SECTION */}
                    <div className="class-section">

                        {classes.map((cls, index) => (
                            <div
                                key={index}
                                className="class-box"
                                onClick={() => {
                                    setActiveClass(cls);

                                    // AUTO SELECT FIRST SUBJECT
                                    const firstSubject = Object.keys(data[cls])[0];
                                    setActiveSubject(firstSubject);
                                }}
                            >
                                <div
                                    className={`icon-wrapper ${activeClass === cls ? "active" : ""}`}
                                >
                                    <div className="icon">
                                        <img src="/pictures/book.png" alt="book" />
                                    </div>
                                </div>

                                <span>{cls}</span>
                            </div>
                        ))}
                    </div>

                    {/* SUBJECT BUTTONS */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "20px",
                            marginBottom: "40px",
                            flexWrap: "wrap",
                        }}
                    >
                        {subjects.map((subject, index) => (
                            <button className="techno-aep-digital-subject-btn"
                                key={index}
                                onClick={() => setActiveSubject(subject)}
                                style={{
                                    padding: "10px 22px",
                                    border: "1px solid #641320",
                                    background:
                                        activeSubject === subject
                                            ? "#641320"
                                            : "#fff",
                                    color:
                                        activeSubject === subject
                                            ? "#fff"
                                            : "#641320",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                            >
                                {subject}
                            </button>
                        ))}
                    </div>

                    {/* CHAPTER CARDS */}
                    <div className="master-card">

                        {chapters.length > 0 ? (
                            chapters.map((chapter, index) => (
                                <div className="maths-card" key={index}>

                                    <h3
                                        style={{
                                            fontFamily: "lora",
                                            fontSize: "1.3rem",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {chapter.name}
                                    </h3>

                                    <div className="techno-aep-digital-button-grid">

                                        {/* STUDY MATERIAL */}
                                        <a
                                            href={chapter.studyMaterial}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button className="techno-aep-digital-btn techno-aep-digital-chapter-btn study-material">
                                                Study Material
                                            </button>
                                        </a>

                                        {/* VIDEO BUTTON */}
                                        <button
                                            className="techno-aep-digital-btn"
                                            onClick={() =>
                                                setOpenVideoIndex(
                                                    openVideoIndex === index
                                                        ? null
                                                        : index
                                                )
                                            }
                                        >
                                            Videos
                                        </button>

                                        {/* VIDEO DROPDOWN */}
                                        <div
                                            className={`techno-aep-digital-video-dropdown ${openVideoIndex === index
                                                ? "show"
                                                : ""
                                                }`}
                                        >
                                            <div className="techno-aep-digital-video-buttons">

                                                {chapter.videos.map(
                                                    (video, vidIndex) => (
                                                        <a
                                                            key={vidIndex}
                                                            href={video}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <button className="techno-aep-digital-small-btn">
                                                                Video {vidIndex + 1}
                                                            </button>
                                                        </a>
                                                    )
                                                )}

                                            </div>
                                        </div>

                                        {/* ASSIGNMENT */}
                                        <a
                                            href={chapter.assignment}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <button className="techno-aep-digital-btn">
                                                Assignment
                                            </button>
                                        </a>

                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="no-chapter-box">

                                <img
                                    src="/pictures/book.png"
                                    alt="No Chapters"
                                    className="no-chapter-icon"
                                />

                                <h3>No Chapters Available</h3>

                                <p>
                                    Study materials, videos and assignments
                                    will be uploaded soon.
                                </p>

                            </div>
                        )}
                    </div>

                </div>
            </section>

        </div>
    );
};

export default TechnoAepDigital;